'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-ad34ecfb.js');

/**
 * Converts the list of `as` to a list of type `t`.
 *
 * @private
 */
function toList(as, t) {
  return t === 'string' ? as.join('') : as;
}

function sortBy(c, as) {
  var bs = Array.from(as.slice(0));
  return toList(bs.sort(c), _rollupPluginBabelHelpers._typeof(as));
}

module.exports = sortBy;
